export var Environment;
(function (Environment) {
    Environment[Environment["production"] = 0] = "production";
    Environment[Environment["stage"] = 1] = "stage";
    Environment[Environment["sqa"] = 2] = "sqa";
    Environment[Environment["integration"] = 3] = "integration";
})(Environment || (Environment = {}));
var initialized = false;
function internalInit(n, t, a, e) {
    var i = 'aptrinsic';
    n[i] =
        n[i] ||
            function () {
                (n[i].q = n[i].q || []).push(arguments);
            };
    n[i].p = e;
    var r = t.createElement('script');
    r.async = !0;
    r.src = a + '?a=' + e;
    var c = t.getElementsByTagName('script')[0];
    c.parentNode.insertBefore(r, c);
}
function init(tagKey, environment) {
    if (environment === void 0) { environment = Environment.production; }
    switch (environment) {
        case Environment.stage:
            tagKey += '-2';
            break;
        case Environment.sqa:
            tagKey += '-3';
            break;
        case Environment.integration:
            tagKey += '-4';
            break;
    }
    internalInit(window, document, 'https://web-sdk.aptrinsic.com/api/aptrinsic.js', tagKey);
    initialized = true;
}
function setContext(context) {
    if (initialized)
        window.aptrinsic('set', 'globalContext', context);
}
function identify(user, account) {
    if (initialized)
        window.aptrinsic('identify', user, account);
}
function track(event, metadata) {
    if (initialized)
        window.aptrinsic('track', event, metadata);
}
export default { init: init, identify: identify, track: track, setContext: setContext };
//# sourceMappingURL=Analytics.js.map